import React from 'react';
import classnames from 'classnames';
import { SearchEntity } from 'v2/models';
import SearchFilter from './SearchFilter';
import MarkdownRender from '../../../components/MarkdownRender/MarkdownRender';
import { FormGroup } from 'react-bootstrap';
import styles from './searchDetailsLeftContent.module.scss';
import { parseSearchFilter } from 'v2/utils/searchUtils';
import SearchBadDescription from 'v2/common/SearchBadDescription/SearchBadDescription';

type LeftContentProps = {
  search: SearchEntity;
  contactedProviders: number;
};

const SearchDetailsLeftContent = ({
  search,
  contactedProviders,
}: LeftContentProps) => {
  return (
    <div>
      <FormGroup className={classnames('border-bottom pb-5')}>
        <p className={classnames('pt-4 mb-2', styles.leftSideSubtitle)}>
          Originator
        </p>
        <p className={classnames('mb-1', styles.originatorName)}>
          {`${search?.submitted_by?.first_name} ${search?.submitted_by?.last_name}`}
        </p>
        <p
          className={classnames(styles.jobTittle)}
        >{`${search?.submitted_by?.job_title}`}</p>
      </FormGroup>
      <FormGroup
        className={classnames(
          search?.filters?.length > 0 || search?.questions?.length > 0
            ? 'border-bottom pb-5'
            : 'pb-5'
        )}
      >
        <label className={classnames('mb-4', styles.leftSideTitles)}>
          Basic Information
        </label>
        <FormGroup>
          <p className={classnames('mb-2', styles.leftSideSubtitle)}>
            Description
          </p>
          <MarkdownRender
            className="markdown-text-blue-light pr-4"
            source={search.description}
            format={true}
            preserveSpaces
          />
        </FormGroup>
        <SearchBadDescription search={search} showContent={true} />
        {!search.free && (
          <FormGroup>
            <p className={classnames('mb-2', styles.leftSideSubtitle)}>
              Shared identity?
            </p>
            <p className={classnames('mb-2', styles.shareIdentityAnswer)}>
              {search.hide_identity ? 'No' : 'Yes'}
            </p>
          </FormGroup>
        )}
      </FormGroup>
      {search?.filters?.length > 0 && (
        <FormGroup
          className={classnames(
            search?.questions?.length > 0 ? 'border-bottom pb-5' : 'pb-5'
          )}
        >
          <label className={classnames('mb-4', styles.leftSideTitles)}>
            Requirements
          </label>
          {!search.free && (
            <FormGroup>
              <p className={classnames('mb-1', styles.leftSideSubtitle)}>
                # of providers contacted
              </p>
              <p className={classnames(styles.providersContactedNumber)}>
                {contactedProviders}
              </p>
            </FormGroup>
          )}
          {search?.filters?.map((item) => (
            <FormGroup key={item.filter.name}>
              <SearchFilter
                label={item.filter.name}
                value={parseSearchFilter(
                  item.data.filter_value,
                  item.data.filter_units
                )}
              />
            </FormGroup>
          ))}
        </FormGroup>
      )}
      {search?.questions?.length > 0 && (
        <FormGroup className={classnames('pb-5')}>
          <label className={classnames('pt-3 mb-4', styles.leftSideTitles)}>
            Questions
          </label>
          {search?.questions?.map((item, index) => (
            <div key={item.id} className="d-flex align-items-center mb-4">
              <p className={classnames('my-0 pr-2', styles.questionNumber)}>
                {index < 10 ? `0${index + 1}` : index + 1}
              </p>
              <label className={classnames('my-0 pl-2', styles.questionText)}>
                {item.name}
              </label>
            </div>
          ))}
        </FormGroup>
      )}
    </div>
  );
};

export default SearchDetailsLeftContent;
